import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Observable, Subject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';





@Injectable({
  providedIn: 'root'
})
export class ServerService {
  private user;
  private listUsers;
  public userObserver: Subject<any> = new Subject();



  customUser: any = ['OvOSoNvxFcd2KDbsLQls32kaveW2', 'Xn9nWDRPeQdK4XhKEZH7Nvv5IIa2']




  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore, private afFunction: AngularFireFunctions) {
    this.initGetAllSubUsers();
  }


  initGetAllSubUsers() {
    this.user = this.afAuth.auth.currentUser;
    this.afs.collection('users').ref.where('parentuid', '==', this.afAuth.auth.currentUser.uid).onSnapshot(d => {
      let docs = d.docs.map(v => { return { id: v.id, data: v.data() } })
      this.listUsers = docs;
      this.userObserver.next(docs)
    })


  }

  updateUserData(id, data) {

    this.afs.collection('users').doc(id).update(data)
  }

  getListUsers() {
    return this.listUsers;
  }

  deleteUser(uid) {
    let deleteUser = this.afFunction.httpsCallable('deleteUser')

    return deleteUser({ uid: uid }).toPromise().then(resolve => {

      this.afs.collection('users').doc(uid).delete();
    })
  }

  deleteSubUser(uid) {
    if (!this.customUser.includes(this.afAuth.auth.currentUser.uid)) {
      let deleteUser = this.afFunction.httpsCallable('deleteUser');

      return deleteUser({ uid: uid }).toPromise().then(result => {

        this.afs.collection('users').doc(uid).delete();
        console.log(result);
      }).catch(err => {
        console.log(err)
      })
    }
    else if (this.customUser.includes(this.afAuth.auth.currentUser.uid)) {

      this.afs.collection('users').doc(uid).delete();
    }
  }

  createUser(email, password, displayName, type) {

    if (!this.customUser.includes(this.afAuth.auth.currentUser.uid)) {
      let createUser = this.afFunction.httpsCallable('createUser');

      return createUser({ email: email, password: password, displayName: displayName, parentuid: this.user.uid, type: type }).toPromise().then(result => {
        //console.log(result)
      }).catch(err => {
        console.log(err)
      })
    }

  }

  getUserPasswordResetLink(email):Promise<any> {
    let linkGeneration = this.afFunction.httpsCallable('getResetPasswordLink')


    return new Promise<any>((resolve, reject) => {
      linkGeneration({ email: email }).toPromise().then(d => {
        console.log("LINK GENERATION OK")
        resolve(d)
      }).catch(err => {
        console.log("LINK GENERATION ERROR:", err)
        reject(err);
      })
    })
 
  }


  createSubUser(email, password, displayName) {


    let createUser = this.afFunction.httpsCallable('createSubUser');


    //console.log(this.afAuth.auth.currentUser.uid)
    if (!this.customUser.includes(this.afAuth.auth.currentUser.uid))
      return createUser({ email: email, password: password, displayName: displayName, parentuid: this.user.uid }).toPromise().then(result => {
        //console.log(result)
      }).catch(err => {
        console.log(err)
      })

    else if (this.customUser.includes(this.afAuth.auth.currentUser.uid)) {

      let newUserId = uuidv4().replaceAll('.', '');

     return  this.afs.collection('users').doc(newUserId).set({ email: email, password: password,displayName: displayName, role: 'subuser', createdAt: new Date(), uid: newUserId, parentuid: this.user.uid })
    }


    /* return new Promise<any>((resolve, reject) => {
       this.afAuth.auth.createUserWithEmailAndPassword(email, password).then(d => {
         //console.log(d.user.uid, this.afAuth.auth.currentUser.uid);
 
 
         return this.afs.collection('users').doc(d.user.uid).set({
           email: email,
           displayName: displayName,
           role: 'subuser',
           createdAt: new Date(),
           uid: d.user.uid,
           parentuid: this.user.uid
         }).then(e => {
           this.afAuth.auth.updateCurrentUser(this.user).then(() => {
             resolve();
           })
 
         }).catch(err => {
           reject(err)
         })
 
 
       }).catch(err => {
         reject(err);
       })
     })*/
  }

}
